import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function CreditCardValidationFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M16.75 2C13.5743 2 11 4.57431 11 7.75C11 10.9257 13.5743 13.5 16.75 13.5C19.9257 13.5 22.5 10.9257 22.5 7.75C22.5 4.57431 19.9257 2 16.75 2ZM16.002 5.3291C16.002 4.91607 16.337 4.58105 16.75 4.58105C17.163 4.58105 17.498 4.91607 17.498 5.3291V7.72754L17.5986 7.76758L18.8438 8.26562C19.2273 8.41914 19.4131 8.85494 19.2598 9.23828C19.1062 9.62167 18.6714 9.80852 18.2881 9.65527L16.4727 8.92871C16.1887 8.81515 16.002 8.54016 16.002 8.23438V5.3291Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.7702 5C9.43444 5.8515 9.25 6.77921 9.25 7.75C9.25 8.5339 9.37027 9.28972 9.59335 10H1.01643C1.01094 10 1.00546 10.0001 1 10.0002V7.75C1 6.23122 2.23122 5 3.75 5H9.7702ZM1 11.4998V19.75C1 21.2688 2.23122 22.5 3.75 22.5H19.75C21.2688 22.5 22.5 21.2688 22.5 19.75V12.5656C21.1242 14.2066 19.059 15.25 16.75 15.25C13.9739 15.25 11.5502 13.7418 10.2534 11.5H1.01643C1.01094 11.5 1.00546 11.4999 1 11.4998ZM10.5 17.75C10.5 17.3358 10.8358 17 11.25 17H12.25C12.6642 17 13 17.3358 13 17.75C13 18.1642 12.6642 18.5 12.25 18.5H11.25C10.8358 18.5 10.5 18.1642 10.5 17.75ZM14.5 17.75C14.5 17.3358 14.8358 17 15.25 17H18.25C18.6642 17 19 17.3358 19 17.75C19 18.1642 18.6642 18.5 18.25 18.5H15.25C14.8358 18.5 14.5 18.1642 14.5 17.75Z"
				fill="currentColor"
			/>
		</svg>
	);
}

CreditCardValidationFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default CreditCardValidationFilledIcon;
